const config = {
  SHOW_DEBUG_TOOLS: process.env.GATSBY_SHOW_DEBUG_TOOLS === "true",
  BRAND_WEBSITE: process.env.GATSBY_BRAND_WEBSITE,
  DASH_URL: process.env.GATSBY_DASH_URL,
  QUOTE_API: process.env.GATSBY_QUOTE_API,
  DASH_API: process.env.GATSBY_DASH_API,
  QUOTE_BFF: process.env.GATSBY_QUOTE_BFF,
  GATEWAY_API: process.env.GATSBY_GATEWAY_API,
  ESTIMATE_ACCEPT_KEY: process.env.GATSBY_ESTIMATE_ACCEPT_KEY,
  GTM_PUBLIC_KEY: process.env.GATSBY_GTM_PUBLIC_KEY,
  AMPLITUDE_PUBLIC_KEY: process.env.GATSBY_AMPLITUDE_PUBLIC_KEY,
  APP_INSIGHTS_INSTRUMENTATION_KEY:
    process.env.GATSBY_APP_INSIGHTS_INSTRUMENTATION_KEY,
  LAUNCHDARKLY_CLIENTID: process.env.GATSBY_LAUNCHDARKLY_CLIENTID,
  SIMULATED_PROFILES_URL: process.env.GATSBY_SIMULATED_PROFILES_URL,
};
export function getConfig() {
  return config;
}
